// Demo categories removed: Only categories created by admin/client in MySQL are displayed
export const defaultCategories = [];

export const categories = [
  { id: 'all', name: 'All Collections', count: 0 }
];

// Demo products removed: Only products uploaded via Admin are displayed
export const products = [];

export const defaultCoupons = [
  {
    id: 'c-1',
    code: 'ROYAL10',
    discountPercent: 10,
    minOrder: 50000,
    description: '10% Royal Privilege Discount on bridal & solitaire jewellery',
    isActive: true,
    expiresAt: '2026-12-31'
  },
  {
    id: 'c-2',
    code: 'GOLD5',
    discountPercent: 5,
    minOrder: 10000,
    description: '5% Instant festive concession across all gold ornaments',
    isActive: true,
    expiresAt: '2026-12-31'
  },
  {
    id: 'c-3',
    code: 'KITCHEN15',
    discountPercent: 15,
    minOrder: 25000,
    description: '15% Off on luxury dining and cookware sets',
    isActive: true,
    expiresAt: '2026-11-30'
  },
  {
    id: 'c-4',
    code: 'DIWALI2026',
    discountPercent: 12,
    minOrder: 75000,
    description: 'Special Festive Dhanteras & Diwali Celebration Code',
    isActive: true,
    expiresAt: '2026-11-15'
  }
];

export const defaultStoreSettings = {
  storeName: 'M.L. Jewellers & Kitchenware',
  tagline: 'Pure BIS 916 Hallmarked Gold, Solitaires & Regal Kitchenware Heritage',
  logoUrl: '',
  faviconUrl: '',
  phone: '+91 98290 12345',
  altPhone: '+91 94140 67890',
  whatsapp: '+91 98290 12345',
  email: 'concierge@mljewellersandkitchenware.com',
  address: 'Main Market Road, Near Clock Tower, Jaipur, Rajasthan - 302001',
  storeAddress: 'Main Market Road, Near Clock Tower, Jaipur, Rajasthan - 302001',
  storeTimings: 'Mon - Sun: 10:30 AM to 08:30 PM (All 7 Days Open)',
  storePhone: '+91 98100 23456',
  storeEmail: 'contact@mljewellers.com',
  storeLocatorBadge: 'Visit Our Flagship Vault Showroom',
  storeLocatorTitle: 'Store Location & Showroom Experience',
  storeLocatorSubtitle: 'Step into our regal showroom to view hand-crafted bridal sets, get certified Karatmeter testing, and trade bullion at live market rates.',
  storeLocatorEnabled: true,
  storeGoogleMapsUrl: 'https://maps.google.com/?q=Main+Market+Road+Near+Clock+Tower+Jaipur+Rajasthan+302001',
  storeAmenity1: 'BIS Karatmeter Testing',
  storeAmenity2: 'Valet Parking Available',
  storeAmenity3: 'Private Bridal Lounge',
  storeAmenity4: 'Zero-Loss Gold Exchange',
  storeVipVisitText: 'Book VIP Visit',
  googleMapsUrl: 'https://maps.google.com/?q=Main+Market+Road+Near+Clock+Tower+Jaipur+Rajasthan+302001',
  aboutStory: 'Purveyors of royal Indian heritage jewellery, BIS 916 hallmarked pure gold, certified solitaire diamonds, and fine kitchenware since 1984. Every creation reflects timeless aristocratic craftsmanship and assay certification.',
  socialLinks: {
    instagram: 'https://instagram.com',
    facebook: 'https://facebook.com',
    youtube: 'https://youtube.com'
  },
  gstin: '08AAAFM1234F1Z8',
  bisLicense: 'HM/C-7689123490',
  hsnJewellery: '7113',
  hsnKitchenware: '7323',
  upiId: 'mljewellers@icici',
  bankName: 'HDFC Bank Ltd, Sarafa Branch',
  accountNo: '50200098765432',
  ifscCode: 'HDFC0001245',
  currency: 'INR (₹)',
  // Razorpay Payment Gateway Configuration
  razorpayKeyId: 'rzp_test_TkcMWJI1AFGNfu',
  razorpayKeySecret: 'G4napswUqQqnHKV7PKworCWf',
  razorpayEnabled: true,
  razorpayTestMode: true,
  courierCharge: 0,
  freeShippingThreshold: 50000,
  courierName: 'BVC Logistics Armored Vault Express',
  defaultAvailability: 'In Stock (Dispatch in 24-48 Hours)',
  defaultDelivery: '3-5 Days (Insured Nationwide Transit)',
  productOffersEnabled: true,
  productOffer1Title: 'Bank Offer',
  productOffer1Text: '10% Instant Discount up to ₹1,500 on HDFC / ICICI Credit Cards',
  productOffer2Title: 'Special Price',
  productOffer2Text: 'Get direct artisan pricing with zero middleman wastage',
  productOffer3Title: 'Special Offer',
  productOffer3Text: "Flat 50% OFF on Making Charges on today's orders",
  productOffer4Title: '',
  productOffer4Text: '',
  deliverySubtitle: '✓ 100% Insured Armored Transit • Verified Pre-Paid Delivery',
  // Registered Office Settings (Admin Customizable - Hidden by default)
  showRegisteredOffice: false,
  registeredCompanyName: 'M.L. Jewellers & Kitchenware Private Limited',
  cinNumber: 'U36911RJ2026PTC099182',
  registeredOfficeBisLicense: 'HM-916-2026-IND',
  registeredOfficeGstin: '08AAECM9182P1ZV',
  registeredOfficeAddress: '',
  // Android App Download Banner in Footer (Admin Customizable - Hidden by default)
  showAppDownloadBanner: false,
  appDownloadTitle: 'M.L. Jewellers Android App',
  appDownloadSubtitle: 'Instant live gold rates, hallmark scanner & zero-wastage calculator on your phone.',
  appDownloadUrl: '/mljewellers-android.apk',
  appDownloadButtonText: 'DOWNLOAD APK (24 MB)',
  adminEmail: 'info@mljewellersandkitchenware.com',
  adminPin: '1234',
  privacyPolicy: `At our jewellery house, we take the confidentiality and security of our esteemed patrons with the utmost sanctity.

1. Information Collection: We gather essential patron contact and address data strictly for order fulfilment, insured armored logistics, and mandatory statutory BIS / GST e-invoicing compliance.
2. Payment Security: All online transactions (Credit/Debit Card, Net Banking, UPI) are tokenized via RBI-approved, PCI-DSS compliant secure gateways. We never store credit card numbers or banking PINs.
3. KYC Verification: For high-value gold and diamond bullion transactions above statutory limits, government-mandated PAN/Aadhaar identity verification is recorded in strictly confidential encrypted vaults.
4. Non-Disclosure: We never sell, rent, or trade your personal or shopping information with third-party advertising networks.
5. Communications: You may opt out of promotional festive WhatsApp or email dispatches at any time by contacting our concierge desk.`,
  termsConditions: `By browsing our catalog or placing an order, you agree to the following terms and conditions:

1. Bullion Pricing Mechanism: All gold and diamond jewellery prices are indexed to the live daily bullion market index. Confirmed orders lock in the agreed bullion price regardless of subsequent market fluctuations.
2. Purity & BIS Certification: Every gold ornament is assayed and laser-engraved with a unique 6-digit HUID (Hallmark Unique Identification) compliant with the Bureau of Indian Standards (BIS). Natural diamonds are accompanied by IGI / GIA verification dossiers.
3. Weight Tolerances: Handcrafted jewellery items may have minor standard manufacturing weight variations of ±0.5%. Final billing is precisely adjusted according to actual certified weights.
4. Order Cancellations: Custom made-to-order bridal sets cannot be canceled once casting and gemstone setting have commenced.
5. Jurisdiction: All disputes are subject to the exclusive jurisdiction of the competent courts in the city of our registered flagship showroom.`,
  returnPolicy: `We stand behind every masterpiece with a transparent, patron-centric guarantee:

1. 15-Day Inspection Guarantee: If any non-customized jewellery piece does not meet your expectations, return it within 15 days in its original unworn condition with the tamper-evident security tag and certificate for a full exchange or store credit.
2. Lifetime 100% Exchange Guarantee: Exchange your pure gold jewellery anytime at our flagship showroom at 100% of the prevailing live bullion market value of net gold weight.
3. Natural Diamond Buyback: Certified natural solitaires and diamond jewellery are eligible for lifetime exchange at 90% of prevailing diamond market rates.
4. Return Transit: Complimentary insured armored courier pickup is arranged for eligible returns across serviceable pincodes.`,
  shippingPolicy: `Every jewel consignment is treated with the highest level of security and discretion:

1. 100% Insured Transit: All consignments are fully insured against loss, theft, or damage from the moment they leave our vault until signed for by the verified patron.
2. Armored Courier Partners: We partner exclusively with specialized secure high-value logistics carriers (BVC Logistics, Blue Dart Apex Armed Escort).
3. Tamper-Evident Packaging: Your jewellery is sealed in a tamper-proof security box with an individual serial seal. Please inspect the seal before signing the delivery manifest.
4. Delivery Timelines: Ready-to-ship vault creations are dispatched within 24-48 hours and typically delivered within 2-5 business days across India.`
};

export const defaultMasterRates = {
  gold: [
    { id: 'gold-24kt', label: '24KT (999)', rate: 7380, isDefault: true },
    { id: 'gold-22kt', label: '22KT (916)', rate: 6765, isDefault: true },
    { id: 'gold-18kt', label: '18KT (750)', rate: 5535, isDefault: true },
    { id: 'gold-14kt', label: '14KT (585)', rate: 4310, isDefault: true },
  ],
  silver: [
    { id: 'silver-999', label: '999 Pure Silver', rate: 89.5, isDefault: true },
    { id: 'silver-925', label: '925 Sterling Silver', rate: 82.5, isDefault: false },
    { id: 'silver-800', label: '800 Traditional Silver', rate: 71.6, isDefault: false },
  ]
};

export const liveGoldRates = {
  gold24K: 7380, // per gram in INR
  gold22K: 6765, // per gram in INR
  gold18K: 5535, // per gram in INR
  silver999: 89.5, // per gram in INR
  lastUpdated: 'Today 10:30 AM IST',
  change: '+0.42%'
};

export const formatINR = (amount) => {
  const num = Number(amount);
  if (isNaN(num)) return '₹0';
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 0
  }).format(num);
};

export const getPriceBreakup = (product) => {
  if (!product) return null;

  // 1. Resolve raw priceBreakup (could be JSON string from MySQL or object)
  let pb = product.priceBreakup;
  if (typeof pb === 'string') {
    try { pb = JSON.parse(pb); } catch (_) { pb = null; }
  }

  // 2. Safely resolve metal/gold amount from all possible keys
  const metalAmt = 
    (product.metalValue !== undefined && Number(product.metalValue) > 0) ? Number(product.metalValue) :
    (product.goldAmount !== undefined && Number(product.goldAmount) > 0) ? Number(product.goldAmount) :
    (pb?.goldAmount !== undefined && Number(pb.goldAmount) > 0) ? Number(pb.goldAmount) :
    (pb?.metalValue !== undefined && Number(pb.metalValue) > 0) ? Number(pb.metalValue) :
    0;

  // 3. Safely resolve making charges from all possible keys
  const makingAmt = 
    (product.makingCharge !== undefined && Number(product.makingCharge) > 0) ? Number(product.makingCharge) :
    (product.makingChargesDiscounted !== undefined && Number(product.makingChargesDiscounted) > 0) ? Number(product.makingChargesDiscounted) :
    (pb?.makingChargesDiscounted !== undefined && Number(pb.makingChargesDiscounted) > 0) ? Number(pb.makingChargesDiscounted) :
    (pb?.makingCharge !== undefined && Number(pb.makingCharge) > 0) ? Number(pb.makingCharge) :
    0;

  const diamondAmt = Number(product.diamondAmount || pb?.diamondAmount || 0);
  const gemstoneAmt = Number(product.gemstoneAmount || pb?.gemstoneAmount || 0);

  // Making charge percentage label
  const makingPct = product.makingChargePercent !== undefined ? product.makingChargePercent : (pb?.makingChargePercent !== undefined ? pb.makingChargePercent : 6.99);

  // Weight
  const weightVal = pb?.weight || product.effectiveWeight || product.netGoldWeight || product.goldWeight || product.weight || product.grossWeight || 1.0;
  const weightStr = typeof weightVal === 'string' && weightVal.toLowerCase().includes('g') ? weightVal : `${weightVal} g`;

  // 4. Fallbacks if metalAmt or makingAmt are not set or 0
  const finalPrice = Number(product.price || pb?.finalTotal) || 0;
  const preTaxFromPrice = Math.round(finalPrice / 1.03);

  let resolvedMetalAmt = metalAmt;
  let resolvedMakingAmt = makingAmt;

  if (resolvedMetalAmt <= 0 && preTaxFromPrice > 0) {
    if (product.category === 'kitchenware') {
      resolvedMetalAmt = preTaxFromPrice;
      resolvedMakingAmt = 0;
    } else {
      const pct = (typeof makingPct === 'number' && makingPct > 0) ? makingPct : 6.99;
      resolvedMakingAmt = Math.round(preTaxFromPrice * (pct / (100 + pct)));
      resolvedMetalAmt = Math.max(0, preTaxFromPrice - resolvedMakingAmt - diamondAmt - gemstoneAmt);
    }
  }

  if (resolvedMakingAmt <= 0 && product.category !== 'kitchenware' && resolvedMetalAmt > 0) {
    const pct = (typeof makingPct === 'number' && makingPct > 0) ? makingPct : 6.99;
    resolvedMakingAmt = Math.round(resolvedMetalAmt * (pct / 100));
  }

  // Taxable, GST, Totals
  const taxableAmt = Number(product.taxableAmount || pb?.taxableAmount) || (resolvedMetalAmt + diamondAmt + gemstoneAmt + resolvedMakingAmt);
  const gstAmt = Number(product.gstAmount || pb?.gstAmount) || Math.round(taxableAmt * 0.03);
  const finalTot = Number(product.price || pb?.finalTotal) || (taxableAmt + gstAmt);
  const originalTot = Number(product.originalPrice || pb?.originalTotal) || Math.round(finalTot * 1.08);

  let diamondWeightStr = product.diamondWeight || pb?.diamondWeight;
  if (!diamondWeightStr && product.diamondCarat) {
    const match = String(product.diamondCarat || '').match(/([0-9.]+)\s*ct/i);
    diamondWeightStr = match ? `${match[1]} ct` : String(product.diamondCarat);
  }

  return {
    goldWeight: weightStr,
    goldAmount: resolvedMetalAmt,
    diamondWeight: diamondWeightStr || (diamondAmt > 0 ? 'Certified Diamond' : null),
    diamondAmount: diamondAmt,
    diamondPieces: product.diamondPieces || pb?.diamondPieces || (diamondAmt > 0 ? 9 : 0),
    diamondClarity: product.diamondClarity || pb?.diamondClarity || (diamondAmt > 0 ? 'SI-HI / VVS' : 'N/A'),
    gemstoneName: product.gemstone || pb?.gemstoneName || (gemstoneAmt > 0 ? 'Natural Gemstones' : null),
    gemstoneAmount: gemstoneAmt,
    makingChargesOriginal: Number(pb?.makingChargesOriginal) || Math.round(resolvedMakingAmt * 1.35),
    makingChargesDiscounted: resolvedMakingAmt,
    makingDiscountPercent: pb?.makingDiscountPercent || `${makingPct}%`,
    taxableAmount: taxableAmt,
    gstAmount: gstAmt,
    gstPercent: '3%',
    originalTotal: originalTot,
    finalTotal: finalTot
  };
};

export const defaultHeroBanner = {
  badge: 'Royal Heritage Since 1988 • Jaipur',
  titleLine1: 'The Sovereign Splendour of',
  titleHighlight: 'Royal Rajputana Jewellery',
  subtitle: 'Experience generational royal craftsmanship with 100% BIS hallmarked 22KT gold, uncut polki chokers, and certified solitaires.',
  primaryBtnText: 'Explore Royal Collections',
  primaryBtnCategory: 'all',
  secondaryBtnText: 'Live Gold Rate Calculator',
  heroImage: 'https://images.unsplash.com/photo-1599643478518-a784e5dc4c8f?auto=format&fit=crop&w=1920&q=85',
  stat1Value: '100%',
  stat1Label: 'BIS Hallmarked',
  stat2Value: '40+ Yrs',
  stat2Label: 'Jewellery Legacy',
  stat3Value: '19,000+',
  stat3Label: 'Insured Pincodes',
  slides: [
    {
      id: 'slide-1',
      badge: '👑 ROYAL RAJPUTANA HERITAGE • 100% BIS 916 PURE GOLD',
      titleLine1: 'The Sovereign Splendour of',
      titleHighlight: 'Royal Rajputana Jewellery',
      subtitle: 'Experience generational royal craftsmanship with 100% BIS hallmarked 22KT gold, uncut polki chokers, and certified solitaires.',
      primaryBtnText: 'Explore Royal Collections',
      primaryBtnCategory: 'all',
      secondaryBtnText: 'Live Gold Rate Calculator',
      video: '/images/jewelry-hero.mp4',
      videoUrl: 'https://assets.mixkit.co/videos/20877/20877-720.mp4',
      image: 'https://images.unsplash.com/photo-1599643478518-a784e5dc4c8f?auto=format&fit=crop&w=1920&q=85'
    },
    {
      id: 'slide-2',
      badge: '✨ CERTIFIED SOLITAIRES & POLKI • 0% MIDDLEMEN MARKUP',
      titleLine1: 'Eternal Sparkle of Certified Solitaires &',
      titleHighlight: 'Artisan Heirloom Gold',
      subtitle: 'Direct workshop pricing with complete transparency, laser-inscribed HUID hallmark purity, and insured armored nationwide transit.',
      primaryBtnText: 'View New Arrivals',
      primaryBtnCategory: 'all',
      secondaryBtnText: 'Live Gold Rate Calculator',
      video: '/images/jewelry-model.mp4',
      videoUrl: 'https://assets.mixkit.co/videos/34427/34427-720.mp4',
      image: 'https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?auto=format&fit=crop&w=1920&q=85'
    },
    {
      id: 'slide-3',
      badge: '💎 IMPERIAL BRIDAL TROUSSEAU 2026',
      titleLine1: 'Imperial Wedding Jewellery &',
      titleHighlight: 'Bespoke Masterpieces',
      subtitle: 'Handcrafted Padmavati chokers, regal bridal necklaces and heritage kadas made to perfection for your unforgettable celebrations.',
      primaryBtnText: 'Explore All Collections',
      primaryBtnCategory: 'all',
      secondaryBtnText: 'Live Gold Rate Calculator',
      image: 'https://images.unsplash.com/photo-1605100804763-247f67b3557e?auto=format&fit=crop&w=1920&q=85'
    }
  ]
};

export const defaultAnnouncements = {
  isEnabled: true,
  showBullionTicker: true,
  marqueeSpeed: 'normal',
  items: [
    '✨ Festive Season Privilege: 0% Making Charges on IGI Certified Solitaires',
    '🛡️ 100% Insured Armored Vault Transit Delivered Across 19,000+ Pincodes',
    '👑 Complimentary Bespoke Monogram Engraving on Heritage Dining Ensembles',
    '💎 Lifetime 100% Exchange Guarantee at Daily Live Bullion Index'
  ]
};

export const defaultStories = [
  {
    id: 'story-1',
    title: 'Bridal 2026',
    img: 'https://images.unsplash.com/photo-1599643478518-a784e5dc4c8f?auto=format&fit=crop&w=300&q=80',
    category: 'bridal',
    badge: 'NEW'
  },
  {
    id: 'story-2',
    title: 'Solitaires',
    img: 'https://images.unsplash.com/photo-1605100804763-247f67b3557e?auto=format&fit=crop&w=300&q=80',
    category: 'rings',
    badge: 'IGI'
  },
  {
    id: 'story-3',
    title: 'Polki & Haar',
    img: 'https://images.unsplash.com/photo-1599643477877-530eb83abc8e?auto=format&fit=crop&w=300&q=80',
    category: 'necklaces',
    badge: 'ROYAL'
  },
  {
    id: 'story-4',
    title: '22K Kadas',
    img: 'https://images.unsplash.com/photo-1611591475822-26c710ffc403?auto=format&fit=crop&w=300&q=80',
    category: 'bangles',
    badge: 'TEMPLE'
  },
  {
    id: 'story-5',
    title: 'Cookware',
    img: 'https://images.unsplash.com/photo-1615865417491-9941019fbc00?auto=format&fit=crop&w=300&q=80',
    category: 'kitchenware',
    badge: 'TRI-PLY'
  },
  {
    id: 'story-6',
    title: '10% OFF Code',
    img: 'https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?auto=format&fit=crop&w=300&q=80',
    category: 'all',
    badge: 'ROYAL10'
  }
];

export const defaultTestimonials = [
  {
    id: 'rev-1',
    name: 'Pooja Kashyap & Vikram Sethi',
    role: 'Destination Wedding, Udaipur',
    quote: 'We ordered our entire bridal trousseau including the Padmavati Polki Choker from M.L. Jewellers. The sheer brilliance of the stones and precision of the meenakari work left every wedding guest mesmerized!',
    rating: 5,
    date: 'February 2026',
    product: 'Padmavati Kundan & Polki Choker Set',
    avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=200&q=80',
    isVerified: true
  },
  {
    id: 'rev-2',
    name: 'Rohan Deshmukh',
    role: 'Verified Buyer, Mumbai',
    quote: 'Purchased the Imperial Solitaire Diamond Ring for my proposal. The IGI certificate accompanied the box, and the sparkle under evening lights is phenomenal. M.L. Jewellers service was truly 5-star.',
    rating: 5,
    date: 'January 2026',
    product: 'Imperial Solitaire Crown Ring',
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=200&q=80',
    isVerified: true
  },
  {
    id: 'rev-3',
    name: 'Meenakshi Sundaram',
    role: 'Family Heirloom Collector, Chennai',
    quote: 'Their Mayura Peacock Kada pairs look straight out of a South Indian royal temple vault. Authentic 22K hallmark verified on the BIS Care app. Outstanding weight authenticity.',
    rating: 5,
    date: 'March 2026',
    product: 'Mayura Temple Peacock Antique Kada',
    avatar: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&w=200&q=80',
    isVerified: true
  },
  {
    id: 'rev-4',
    name: 'Princess Ananya Singh',
    role: 'Civil Lines, Jaipur',
    quote: 'The Royal Tri-Ply Master Chef Cookware Set is pure culinary perfection. Heavy gauge, meticulously crafted, and delivered with exquisite care.',
    rating: 5,
    date: 'August 2026',
    product: 'Royal Tri-Ply 5-Piece Master Chef Cookware Set',
    avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=200&q=80',
    isVerified: true
  }
];

export const defaultTrustPillars = [
  {
    id: 'trust-1',
    title: '100% BIS 916 Hallmarked',
    desc: 'Assayed with laser-engraved HUID, purity fineness, and triangular BIS standard seal.',
    iconName: 'ShieldCheck'
  },
  {
    id: 'trust-2',
    title: 'Insured Armored Transit',
    desc: 'Every consignment shipped in tamper-evident sealed security vaults with transit insurance.',
    iconName: 'Truck'
  },
  {
    id: 'trust-3',
    title: 'Lifetime 100% Exchange',
    desc: 'Transparent buyback and exchange guarantee valued on real-time daily bullion index.',
    iconName: 'RefreshCw'
  },
  {
    id: 'trust-4',
    title: 'Natural & Certified Stones',
    desc: 'Each solitaire and diamond accompanied by international IGI / GIA verification dossiers.',
    iconName: 'Award'
  }
];

export const defaultPromoPopup = {
  isEnabled: false,
  title: 'Royal Privilege Celebration',
  subtitle: 'Unlock flat 10% instant concession on your royal bridal trousseau or diamond engagement purchase.',
  couponCode: 'ROYAL10',
  discountBadge: 'FESTIVE 10% OFF',
  bannerImg: 'https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?auto=format&fit=crop&w=800&q=80',
  btnText: 'Claim Royal Privilege Pass'
};
